<template>
  <div class="component-content configuration-bottlecages">
    <div class="component-content-scroll">
      <div class="component-content-title mb-3">Select your cages</div>

      <option-list
        :options="cagesbottleInput"
        :target="this.results.cagebottle"
        :inputName="'cagebottle'"
        v-on:target-updated="updateData"
      ></option-list>

      <div class="mt-3">
        Nb. All cages come with 2x passoni water bottles
      </div>

      <div
        class="color-selector mt-4 pt-2"
        v-if="showColorSelector()">
        <ColorSelector
          :primaryColor="results.colour.primaryColor"
          :secondaryColor="results.colour.secondaryColor"
          :colors="colors"
          :componentId="this.results.cagebottle.id"
          :componentType="'cagebottle'"
          :results="results"
          v-on:component-color-selected="selectColor"
        ></ColorSelector>
      </div>
    </div>
    <div class="buttonset">
      <button class="btn btn-outline-dark back-button" v-on:click="goBack">
        back
      </button>
      <finish-configuration-button
        v-if="canFinishConfiguration()"
        v-on:finish-configuration="finishConfiguration"
       ></finish-configuration-button>
      <button class="btn btn-outline-dark next-button" v-on:click="goNext">
        next
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import OptionList from "../../shared/optionList.vue";
import ColorSelector from "../../shared/component-color-selector.vue";
import FinishConfigurationButton from './finish-configuration-button.vue';

Vue.component("finish-configuration-button", FinishConfigurationButton);

export default {
  name: "configuration-bottlecages",
  data() {
    return {};
  },
  components: {
    OptionList,
    ColorSelector,
  },
  props: [
    "configuratorSteps",
    "currentStep",
    "results",
    "components",
    "measures",
    "colors",
    "bike",
  ],
  methods: {
    goNext: function () {
      if (this.results.cagebottle == null) {
        this.$emit("set-error", "Please select a bottle cage");
        return false;
      }
      if (
        this.results.cagebottle != null &&
        this.results.cagebottle.id == 41 &&
        this.results.colour.type.id != 993 &&
        typeof this.results.cagebottle.colour == 'undefined'
      ) {
        this.$emit("set-error", "Please select a bottle cage colour");
        return false;
      }
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
    showColorSelector: function () {
      if (
        this.results.cagebottle != null &&
        this.results.cagebottle.is_paintable
      ) {
       //console.log(['this.results.fork != "undefined"','this.results.stem != null','this.results.stem.id']);
       //console.log([this.results.fork != "undefined",this.results.fork != null,this.results.fork.id])
        return true;
      }
      return false;
    },
    selectColor: function (color, componentId, componentType) {
      this.$emit("component-color-selected", color, componentId, componentType);
    },
    updateData: function (e) {
      this.cagesbottleInput = e;
    },
    canFinishConfiguration: function() {
       // if fork is present, we need to check if the fork is selected and has a colour
        if (this.components.fork?.length > 0) 
        {
          return (
          this.results.frame !== null &&
          this.results.frame !== undefined &&
          this.results.colour !== null &&
          this.results.colour !== undefined &&
          this.results.fork !== null &&
          this.results.fork !== undefined
          );
        }
        else
        {
          // no fork, so we can finish configuration
          return (
            this.results.frame !== null &&
            this.results.frame !== undefined &&
            this.results.colour !== null &&
            this.results.colour !== undefined
          );
        }
    },
    finishConfiguration: function() {
        this.$emit("finish-configuration");
    },
  },
  computed: {
    cagesbottleInput: {
      get: function () {
        return this.components.bottlecages[0];
      },
      set: function (e) {
        this.$emit("set-bottlecages", e);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.configuration-bottlecages {
}
</style>

